import React from 'react';
import { useSelector } from 'react-redux';
import { Container } from '@yme/atoms/grid';
import { getRTL } from '@yme/selectors/common';
import { buildKey } from '@yme/utils/common';
import { IndentWrapper } from '../Separator/IndentWrapper';
import { TAGS_DATA_TEST_ID } from './constants';
import { buildListingPageLink } from './helpers';
import { TagsStyled, TagStyled } from './styled';
export function Tags(props) {
    const { listingPageLink, tags, isRemoveBottomIndent } = props;
    const isRightToLeft = useSelector(getRTL);
    if (tags.length) {
        return (React.createElement(IndentWrapper, { isRemoveBottomIndent: isRemoveBottomIndent },
            React.createElement(Container, { dataTestId: TAGS_DATA_TEST_ID, isRightToLeft: isRightToLeft },
                React.createElement(TagsStyled, { justifyContent: "center", gap: "8px", flexWrap: "wrap" }, tags.map((tag, index) => (React.createElement(TagStyled, { key: buildKey(index, tag.value), to: buildListingPageLink(listingPageLink, tag.value) }, tag.title)))))));
    }
    return null;
}
Tags.displayName = 'Tags_AEMComponent';
